import React from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faYahoo } from '@fortawesome/free-brands-svg-icons';
import { Link } from "react-router";

const StyledFooter = styled.footer`
    width: 100%;
    background-color: ${palette.neutral12};
    padding: 44px 20px;
    color: ${palette.neutral1};

    @media (min-width: 800px) {
        padding: 90px 20px;
    }

    div.footer-container {
        max-width: 1096px;
        margin-left: auto;
        margin-right: auto;
    }

    .hover-underline::before {
        width: 0%;
        transition: all 200ms ease;
        position: relative;
        display: inline-block;
        z-index:0;
    }
    
    .hover-underline::before {
        transition: 250ms;
        height: 2px;
        content: "";
        position: absolute;
        bottom: -2px;
        background-color: ${palette.neutral1};
        border-radius: 2px;
    }

    p {
        margin: 0;

        &.h1 {
    
            span {
                background: ${palette.gradientMain};
                background: ${palette.gradientMain};
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: 22px;
                margin: 0;

                @media (min-width: 347px) {
                    font-size: 26px;
                }
        
                @media (min-width: 394px) {
                    font-size: 30px;
                }

                @media (min-width: 800px) {
                    font-size: 34px;
                }
            }
        }
    
        &.h3 {
            color: ${palette.neutral1};
            margin: 0;
            font-size: 20px;
    
            @media (min-width: 394px) {
                font-size: 24px;
            }

            @media (min-width: 800px) {
                font-size: 28px;
            }
        }
    }

    div.footer-info {

        @media (min-width: 800px) {
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-end;
            justify-content: space-between;
        }

        div.contact-links {
            margin: 52px 0;

            @media (min-width: 800px) {
                margin: 52px 0 0 0;
            }
    
            div {
    
                a, a:active, a:visited {
                    display: inline-flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    color: var(--neutral-1);
                    text-decoration: none;
                    font-weight: 600;
                    text-underline-offset: 6px;
                    text-decoration-color: var(--neutral-1);
    
                    &:hover, &:focus-visible {
                        color: var(--neutral-1);

                        .hover-underline::before {
                            width: 100%;
                        }
                    }

                    &:focus-visible {
                        outline: 3px solid ${palette.blue5};
                        outline-offset: 8px;
                        border-radius: 4px;
                    }
    
                    span {
                        display: inline-block;
                        width: 28px;
                    }
                }
            }
        }
    
        div.copyright {
            @media (min-width: 800px) {
                text-align: right;
            }

            .copyright-1p {
                padding-bottom: 16px;
    
                @media (min-width: 800px) {
                    padding-bottom: 24px;
                }
            }

            .copyright-2p {
                margin-bottom: 16px;

                @media (min-width: 800px) {
                    margin-bottom: 0;
                }
            }
        }
    }
`;

const Footer = () => {
    return (
        <StyledFooter>
            <div className={"footer-container"}>
                <p className={"h1"}><span>Thanks for stopping by</span></p>
                <p className={"h3"}>Let's connect&nbsp;&#128172;</p>
                <div className={"footer-info"}>
                    <div className={"contact-links"}>
                        <div style={{paddingBottom: 24}}>
                            <Link to="mailto:courtneycsherrod@gmail.com?subject=Nice to meet you Courtney!">
                                <span><FontAwesomeIcon icon={faEnvelope} style={{fontSize: 20}}/></span>
                                <p className={"hover-underline"}>courtneycsherrod@gmail.com</p>
                            </Link>
                        </div>
                        <div>
                            <Link to="https://linkedin.com/in/courtneysherrod" target="_blank" rel="noopener noreferrer">
                                <span><FontAwesomeIcon icon={faLinkedin} style={{fontSize: 20}}/></span>
                                <p className={"hover-underline"}>linkedin.com/in/courtneysherrod</p>
                            </Link>
                        </div>
                    </div>
                    <div className={"copyright"}>
                        <p className={"copyright-1p"}>Designed and developed with love by&nbsp;Courtney&nbsp;Sherrod</p>
                        <p className={"copyright-2p"}>Copyright &copy; 2026</p>
                    </div>
                </div>
            </div>
        </StyledFooter>
    )
}

export default Footer;